import { Link } from "react-router"
import { ArrowUpRight } from "./layout"
import { PageHero } from "./components"
import { usePublicEvents } from "./api"
import { toEventCard } from "./home/events"

function EventCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-sm" aria-hidden="true">
      <div className="h-[260px] animate-pulse bg-cream-200" />
      <div className="space-y-4 bg-forest-950 p-6">
        <div className="h-5 w-2/3 animate-pulse rounded bg-white/20" />
        <div className="h-5 w-4/5 animate-pulse rounded bg-white/20" />
        <div className="h-4 w-full animate-pulse rounded bg-white/10" />
        <div className="h-4 w-5/6 animate-pulse rounded bg-white/10" />
        <div className="pt-2">
          <div className="h-10 w-32 animate-pulse rounded-full bg-white/20" />
        </div>
      </div>
    </div>
  )
}

export function EventsPage() {
  const { data, loading } = usePublicEvents()
  const events = data?.map(toEventCard) ?? []

  return (
    <>
      <PageHero
        eyebrow="Events & Programs"
        eyebrowDot
        title={<>What’s <span className="text-forest-700">happening next.</span></>}
        lede="Programs for our scholars, workshops for the women in our communities, and moments that bring the whole Redempta family together."
      />

      <section className="bg-cream-50 pb-[597px] pt-16 lg:pb-[69px] lg:pt-[37px]">
        <div className="public-container">
          <div className="rounded-[32px] bg-gold-500 p-6 sm:p-10">
            <div className="grid items-start gap-6 md:grid-cols-3 lg:h-full">
              {loading ? (
                <div className="col-span-full grid gap-6 md:grid-cols-3" role="status" aria-label="Loading events">
                  <EventCardSkeleton />
                  <EventCardSkeleton />
                  <EventCardSkeleton />
                </div>
              ) : events.length === 0 ? (
                <p className="col-span-full py-10 text-center text-sm text-ink/70">New public events will appear here soon.</p>
              ) : events.map((event) => (
                <article key={`${event.title}-${event.meta}`} className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm">
                  <img src={event.image} alt={event.alt} className="h-[260px] w-full object-cover" loading="lazy" />
                  <div className="flex flex-1 flex-col bg-forest-950 p-6">
                    <p className="inline-flex items-center gap-2 text-base text-white/75">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" aria-hidden>
                        <rect x="3" y="5" width="18" height="17" rx="2" />
                        <path d="M8 2v4M16 2v4M3 10h18" />
                      </svg>
                      {event.meta}
                    </p>
                    <h3 className="mt-3 text-base font-semibold leading-snug text-white">{event.title}</h3>
                    <p className="mt-2 text-base text-white/80">{event.description}</p>
                    <div className="mt-auto pt-6">
                      <Link to={event.id ? `/events/${event.id}` : "/contact"} className="inline-flex items-center gap-2.5 rounded-full bg-forest-950 py-1 pl-4 pr-1 text-sm font-semibold text-white transition-colors hover:bg-forest-800">
                        Learn More
                        <span className="grid h-8 w-8 place-items-center rounded-full bg-white text-forest-950">
                          <ArrowUpRight className="h-4 w-4" />
                        </span>
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
